<template>
  <div id="home">
    <loading-screen />
    <parallax-header v-view="headerViewHandler"/>
    <home-links />
    <good2-know :title="fields.good2know" />
    <div id='area'></div>
    <Area :title="fields.area" :lead="fields.areaLead" />
    <div id='events'></div>
    <events :title="fields.events"/>
    <pilatus :title="fields.pilatus" />
    <span id='culture'></span>
    <span id='hotels'></span>
    <span id='restaurants'></span>
    <span id='shopping'></span>
    <places />
    <div id='sights'></div>
    <sights :title="fields.sights" />
    <div id='trips'></div>
    <trips :title="fields.trips" />
    <div id='arrival'></div>
    <arrival :title="fields.arrival" />
  </div>
</template>

<script>
import LoadingScreen from '../components/LoadingScreen.vue'
import ParallaxHeader from '../components/ParallaxHeader.vue'
import HomeLinks from '../components/HomeLinks.vue'
import Area from '../components/Area.vue'
import Pilatus from '../components/Pilatus.vue'
import Events from '../components/Events.vue'
import Places from '../components/Places/Places.vue'
import Good2Know from '../components/Good2know/Good2Know.vue'
import Sights from '../components/Sights/Sights.vue'
import Trips from '../components/Trips/Trips.vue'
import Arrival from '../components/Arrival.vue'

import EventBus from '../EventBus'

export default {
  name: 'Home',
  components: {
    LoadingScreen,
    ParallaxHeader,
    HomeLinks,
    Area,
    Pilatus,
    Events,
    Places,
    Sights,
    Good2Know,
    Trips,
    Arrival
  },
  data () {
    return {
      fields: {
        good2know: null,
        sights: null,
        sightsLead: null,
        trips: null,
        tripsLead: null,
        events: null,
        eventLead: null,
        area: null,
        areaLead: null,
        arrival: null,
        arrivalLead: null
      }
    }
  },
  methods: {
    async getContent (language) {
      let document = await this.$prismic.client.getSingle('homelinks', {lang: language})
      if (document) {
        this.fields.good2know = document.data.good2know[0].text
        this.fields.sights = document.data.sights[0].text
        this.fields.sightsLead = document.data.sightslead
        this.fields.trips = document.data.trips[0].text
        this.fields.tripsLead = document.data.tripslead
        this.fields.events = document.data.events[0].text
        this.fields.eventLead = document.data.eventslead
        this.fields.area = document.data.area[0].text
        this.fields.areaLead = document.data.arealead
        this.fields.arrival = document.data.arrival[0].text
        this.fields.arrivalLead = document.data.arrivallead
      }
    },
    headerViewHandler (e) {
      if (e.percentCenter <= -0.4) {
        EventBus.$emit(EventBus.constants.NAVIGATION_CLASS_CHANGED, '')
      } else {
        EventBus.$emit(EventBus.constants.NAVIGATION_CLASS_CHANGED, 'navigation--transparent')
      }
    }
  },
  async created () {
    EventBus.$emit(EventBus.constants.NAVIGATION_CLASS_CHANGED, 'navigation--transparent')

    await this.getContent(window.KriensTourismus.language)
    // Listen to Language Change
    EventBus.$on(EventBus.constants.LANGUAGE_CHANGED, (language) => this.getContent(language))
  }
}
</script>